var MDB = window.MDB || {};;
MDB.DPN = MDB.DPN || {};
MDB.DPN.Cancellation = MDB.DPN.Cancellation || {};

(function($){
    var dataSource
        , searchForm;


    $.extend(MDB.DPN.Cancellation, {
        boot: function(){
            searchForm = $('#search-form');

            searchForm.on('submit', function(e){
                e.preventDefault();

                MDB.DPN.Cancellation.search();
            });

		    var grid = $('#grid')
		        , crudBaseUrl = document.location.origin + '/api/DPN/Cancellation'
		        , config = grid.data('config')
                , dropdownEditorFields = _.map(Object.keys(config['dropdownConfigs']), function(k) {
                    return k.replace('_', '')
                });

            config.columns.forEach(function (column) {
                column.encoded = false;

                var field = config.model.fields[column.field];
                if (field && field.type) {
                    if(dropdownEditorFields.indexOf(column.field) !== -1) {
                        column.editor = dropDownEditor;
                    }

                    if (field.type === 'boolean') {
                        column.template = MDB.KendoConfigBuilder.gridBooleanYesNoTemplate(column.field);
                    }
                }
            });

            config.columns.unshift(MDB.KendoConfigBuilder.gridCommandColumn({
            	name: 'edit',
                text: {
                    edit: MDB.loadResourceString('RetentionAddStateModel_EditButton_DisplayName'),
                    update: MDB.loadResourceString('RetentionAddStateModel_UpdateButton_DisplayName'),
                    cancel: MDB.loadResourceString('RetentionAddStateModel_CancelButton_DisplayName')
                }
            }));

            dataSource = new kendo.data.DataSource({
                transport: {
                    read: function (opts) {
                        var url = crudBaseUrl + '/search/?' + searchForm.serialize();
                        MDB.KendoConfigBuilder.dataSourceTransportFunction(url, 'GET', opts);
                    },
                    update: function (opts) {
                    	//TODO: Resource -> Generic update error
                        opts.error = function (res) {
                            MDB.alert('Er is een fout opgetreden bij het verwerken, probeer het opnieuw');
                        }

                        var url = crudBaseUrl + '/Register/';
                        MDB.KendoConfigBuilder.dataSourceTransportFunction(url, 'PUT', opts);
                    }
                },
                error: function (e) {
                    MDB.alert(MDB.KendoConfigBuilder.getWebApiErrorsMessage(e));
                },

                pageSize: 20,
                autoSync: false,
                schema: {
                    model: config.model
                }
            });

            grid.kendoGrid({
                dataSource: dataSource,
                pageable: false,
                autoBind: false,

                columns: config.columns,
                messages: {
                    commands: MDB.KendoConfigBuilder.commandLabels(),
                    noRecords: MDB.loadResourceString('DataTable_ZeroRecords')
                },
                navigatable: true,
                sortable: { mode: 'multiple' },
                scrollable: false,
                editable: 'popup',

                edit: function (e) {
                    //Ensure record is dirty, so it always gets submitted
                    e.model.dirty = true;

                    var container = $(e.container);
                    
                    container.find('[name$="shouldUndertakeAction"]').on('change', function(){
                        var fun = this.checked ? 'show' : 'hide';
                        var target = container.find('[data-container-for$="actionId"]');

                        //input
                        target[fun]();

                        //label
                        target.prev()[fun]();
                    }).trigger('change');

                    MDB.KendoConfigBuilder.hideColumnsOnEdit(e);
                }
            });

            function dropDownEditor(e, opts){
                var dropdownConfig = config['dropdownConfigs']["_" + opts.field];

                $.extend(dropdownConfig, {
                    change: function () {
                        setFieldValue(opts.model.id, opts.field, this.value());
                    }
                });

                var dropdown = $(sprintf('<input name="%s" />', opts.field))
                    .appendTo(e)
                    .kendoDropDownList(dropdownConfig);


                var exists = _.filter(_.map(dropdownConfig.dataSource.data, dropdownConfig.dataValueField), function(v){
	                return v == opts.model[opts.field];
                }).length;

                if(!exists){
                    setFieldValue(opts.model.id, opts.field, dropdown.val());
                }
            }

            function setFieldValue(modelId, field, val) {

                dataSource.get(modelId).set(field, val);
            }
        },
        search: function(){
            if ($(searchForm).valid()) {
                dataSource.read();
            }
        }
    });
})(jQuery);